import React from 'react';
import { List as VesselsList } from '../vessels';
import { List as PortsList } from '../ports';
import { List as CountriesList } from '../countries';
import { List as CurrenciesList } from '../currencies';
import { List as DepartmentsList } from '../departments';
import { List as ManagementCompaniesList } from '../management-companies';
import { List as EntitiesList } from '../../entities';
import {
  ReferenceCategoryWorkspace,
  type ReferenceNavItem,
} from './ReferenceCategoryWorkspace';

const BASE = '/parameters/general';

const ITEMS: ReferenceNavItem[] = [
  { id: 'vessels', label: 'Vessels', description: 'Fleet register', permissionModuleKey: 'vessels' },
  {
    id: 'management-companies',
    label: 'Management companies',
    description: 'Ship managers for vessels',
    permissionModuleKey: 'management_companies',
  },
  { id: 'ports', label: 'Ports', description: 'Ports by country', fillHeight: true, permissionModuleKey: 'ports' },
  { id: 'entities', label: 'Entities', description: 'Suppliers & companies', permissionModuleKey: 'suppliers' },
  { id: 'countries', label: 'Countries', description: 'Country codes & names', permissionModuleKey: 'countries' },
  { id: 'currencies', label: 'Currencies', description: 'Currency codes', permissionModuleKey: 'currencies' },
  { id: 'departments', label: 'Departments', description: 'Org departments', permissionModuleKey: 'departments' },
];

function renderPanel(section: string) {
  switch (section) {
    case 'vessels':
      return <VesselsList />;
    case 'management-companies':
      return <ManagementCompaniesList />;
    case 'ports':
      return <PortsList />;
    case 'entities':
      return <EntitiesList />;
    case 'countries':
      return <CountriesList />;
    case 'currencies':
      return <CurrenciesList />;
    case 'departments':
      return <DepartmentsList />;
    default:
      return null;
  }
}

const GeneralReferenceWorkspace: React.FC = () => (
  <ReferenceCategoryWorkspace
    basePath={BASE}
    eyebrow="General"
    items={ITEMS}
    defaultSection="vessels"
    renderPanel={renderPanel}
  />
);

export default GeneralReferenceWorkspace;
